import { createFetchedDataRecord, updateObject } from '@vista-digital/utilities';
import { browsingDomainStore } from '../../../store';
import { getQueryKeyForFilmAvailability } from '../../../utils/films/film-availability-utils';
import { assignFilmAvailabilityRelatedData, assignFilmListRelatedData } from './assign-related-data';
export const onFilmListLoadSuccess = (response, cacheDuration) => {
    const { films, relatedData } = response;
    updateObject(browsingDomainStore.data.filmsById, createFetchedDataRecord(films, 'id', cacheDuration));
    assignFilmListRelatedData(relatedData, cacheDuration);
    return films.map(film => film.id);
};
export const onFilmAvailabilityListLoadSuccess = (response, cacheDuration) => {
    const { filmAvailabilities, relatedData } = response;
    updateObject(browsingDomainStore.data.filmAvailabilitiesByQuery, createFetchedDataRecord(filmAvailabilities, getQueryKeyForFilmAvailability, cacheDuration));
    assignFilmAvailabilityRelatedData(relatedData, cacheDuration);
    return undefined;
};
//# sourceMappingURL=on-success.js.map